export const getters = {
  menuBannerRecommendationList: ({ menuBannerRecommendationList }) => menuBannerRecommendationList,
};
